import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';

const STATIC_RHCA_BLOG = {
  id: 'rhca-blog-post',
  title: 'A New Ray of Hope Begins at Electronics City',
  description: 'Ray of Hope Center for Autism (RHCA) marked a significant milestone with the launch of its new center at RR Towers...',
  main_image: 'https://images.unsplash.com/photo-1527525443983-6e60c75fff46?w=1200&q=80',
  date: '2025-12-13T00:00:00.000Z',
  username: 'Rachel George'
};

const STATIC_CAREGIVER_BLOG = {
  id: 'caregiver-support-blog-post',
  title: 'Supporting the Supporters: Caregiver Burnout in Autism',
  description: 'Behind every therapy session, IEP meeting, and progress milestone is a caregiver. But what happens when the caregiver runs on empty?',
  main_image: '/assets/images/blog/hero-mother-exhausted.jpeg',
  date: '2026-02-15T00:00:00.000Z',
  username: 'Rachel George'
};

function BlogsPageSession() {
  const [blogs, setBlogs] = useState([STATIC_RHCA_BLOG, STATIC_CAREGIVER_BLOG]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 8000); // 8-second timeout

    const fetchBlogs = async () => {
      try {
        const response = await fetch(`${config.apiBaseUrl}/blogs/api/blogs`, { signal: controller.signal });
        const data = await response.json();
        
        if (data.success) {
          setBlogs([STATIC_RHCA_BLOG, STATIC_CAREGIVER_BLOG, ...data.data]);
        }
      } catch (err) {
        if (err.name === 'AbortError') {
          console.error('Fetch aborted due to timeout');
        } else {
          console.error('Failed to fetch dynamic blogs:', err);
        }
      } finally {
        clearTimeout(timeoutId);
        setLoading(false);
      }
    };

    fetchBlogs();
    return () => {
      controller.abort();
      clearTimeout(timeoutId);
    };
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return {
      day: date.getDate(),
      month: date.toLocaleString('default', { month: 'short' })
    };
  };

  if (loading) {
    return <div className="container text-center py-5">Loading blogs...</div>;
  }

  if (blogs.length === 0) {
    return <div className="container text-center py-5">No blogs found</div>;
  }

  return (
    <section className="blog-one">
      <div className="container">
        <div className="row">
          {blogs.map((blog, index) => {
            const formattedDate = formatDate(blog.date);
            
            return (
              <div 
                key={blog.id} 
                className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp" 
                data-wow-delay={`${(index + 1) * 100}ms`}
              >
                <div className="blog-one__single">
                  <div className="blog-one__img-box">
                    <div className="blog-one__img">
                      <img 
                        src={blog.main_image.startsWith('http') || blog.main_image.startsWith('assets/') || blog.main_image.startsWith('/assets/') ? blog.main_image : `${config.apiBaseUrl}/uploads/${blog.main_image}`} 
                        alt={blog.title} 
                        style={{ height: '300px', objectFit: 'cover' }}
                        onError={(e) => {
                          e.target.src = 'assets/images/blog/blog-1-1.jpg';
                        }}
                      />
                      <Link to={`/blog-details/${blog.id}`}>
                        <span className="blog-one__plus"></span>
                      </Link>
                      <div className="blog-one__date">
                        <p>{formattedDate.day}<br />{formattedDate.month}</p>
                      </div>
                    </div>
                    <div className="blog-one__content-top">
                      <div className="blog-one__content-img">
                        <img 
                          src="assets/images/placeholder.jpg" 
                          alt="Author" width={10} height={50}
                        />
                      </div>
                      <p className="blog-one__content-sub-title">by {blog.username}</p>
                      <h3 className="blog-one__content-title">
                        <Link to={`/blog-details/${blog.id}`}>{blog.title}</Link>
                      </h3>
                    </div>
                  </div>
                  <div className="blog-one__content">
                    <div className="blog-one__comment-and-btn">
                      <div className="blog-one__btn">
                        <Link to={`/blog-details/${blog.id}`}>
                          <span className="icon-right-arrow"></span>More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default BlogsPageSession;